var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "products.create",
              expression: "'products.create'",
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { 400: true },
            },
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew },
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" },
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew"))),
          ]),
        ],
        1
      ),
      _c("Grid", {
        attrs: {
          service: _vm.service,
          route_name: "products",
          order_column: "name",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID"),
                ]),
                _c("vs-th", { key: "name", attrs: { "sort-key": "name" } }, [
                  _vm._v(_vm._s(_vm.$t("product.name"))),
                ]),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v(_vm._s(_vm.$t("product.status")))]
                ),
                _c("vs-th", { key: "price", attrs: { "sort-key": "price" } }, [
                  _vm._v(_vm._s(_vm.$t("product.price"))),
                ]),
                _c(
                  "vs-th",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: "home_highlights.edit",
                        expression: "'home_highlights.edit'",
                      },
                    ],
                    key: "featured",
                  },
                  [_vm._v(_vm._s(_vm.$t("product.featured")))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.id) + " ")]),
                    ]),
                    _c("vs-td", { key: "name", attrs: { width: "40%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.name))]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "status", attrs: { width: "15%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color: _vm.getStatusColor(
                                _vm._.get(tr, "status")
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.formatStatus(_vm._.get(tr, "status")))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("vs-td", { key: "price", attrs: { width: "18%" } }, [
                      _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm.formatValue(_vm._.get(tr, "price")))
                        ),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "home_highlights.edit",
                            expression: "'home_highlights.edit'",
                          },
                        ],
                        key: "featured",
                        attrs: { width: "12%" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "featured-cell",
                            attrs: { title: _vm.$t("product.featured_hint") },
                          },
                          [
                            _c("input", {
                              staticClass: "featured-input",
                              attrs: {
                                type: "number",
                                min: "1",
                                max: "9999",
                                placeholder: "—",
                              },
                              domProps: { value: tr.featured_order },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return $event.target.blur()
                                },
                                change: function ($event) {
                                  return _vm.onFeaturedChange(tr, $event)
                                },
                              },
                            }),
                            tr.featured_order
                              ? _c("feather-icon", {
                                  staticClass:
                                    "h-4 w-4 stroke-current text-danger cursor-pointer",
                                  attrs: {
                                    icon: "XIcon",
                                    title: _vm.$t("Delete"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveFeatured(tr, null)
                                    },
                                  },
                                })
                              : _c("feather-icon", {
                                  staticClass:
                                    "h-4 w-4 stroke-current text-secondary",
                                  attrs: { icon: "StarIcon" },
                                }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("vs-td", { attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "products.edit",
                                expression: "'products.edit'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                            attrs: { icon: "EditIcon" },
                            on: {
                              click: function ($event) {
                                return props.edit(props.data[indextr].id)
                              },
                            },
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "products.delete",
                                expression: "'products.delete'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                            attrs: { icon: "Trash2Icon" },
                            on: {
                              click: function ($event) {
                                return props.destroy(props.data[indextr])
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }